import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
/**
 * Custom breakpoint configuration for AgentNet. To be extended by each brand where needed.
 *
 * @returns {Breakpoints}
 */
export const breakpoints = createBreakpoints({
    values: {
        xs: 0,
        sm: 600,
        md: 1280,
        lg: 1440,
        xl: 1537,
        xxl: 1920,
    },
});
